const VIEW_DELETED_ROLES = ["superadmin"]; // add "admin" here later

export const canViewDeleted = (userRoles: string[] = []) =>
  userRoles?.some(role => VIEW_DELETED_ROLES.includes(role));